import { Controller } from '@hotwired/stimulus';

export default class MerchandisePurchaseSummary extends Controller {
  static targets = [
    'itemsCount',
    'totalAmount',
    'quantity',
    'submit'
  ];

  connect() {
    this.update();
  }

  update() {
    this.itemsCountTarget.textContent = this.quantityTargets.filter((quantity) => Number(quantity.value) > 0).length;

    const totalAmount = this.quantityTargets.reduce((acc, quantity) => {
      return acc + Number(quantity.dataset.amount) * Number(quantity.value);
    }, 0);

    this.totalAmountTarget.textContent = Intl.NumberFormat('ja-JP').format(totalAmount);

    this.submitTarget.disabled = totalAmount === 0;
  }
}
